import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import * as amplitude from "@amplitude/analytics-browser";
import { SHARED_EVENTS_PARAMS } from "@app/dashboard/constants/tracking_events/shared";
import {
  HOME_PAGE_EVENTS,
  HOME_PAGE_EVENTS_PARAMS
} from "@app/dashboard/constants/tracking_events/home";
import { useIntegrationsStore } from "@app/dashboard/store/integrations";
import { useFiltersStore } from "@app/dashboard/store/home/filters";
import DateRangesCompare from "@app/dashboard/components/inner_layout/DateRangesCompare";
import Shortcuts from "@app/dashboard/components/inner_layout/Shortcuts";
import FiltersDropdowns from "@app/dashboard/components/inner_layout/FiltersDropdowns";
import styles from "./overview.module.scss";


const Overview = () => {
  const { t } = useTranslation();
  const { isLoading } = useIntegrationsStore();
  const { filters } = useFiltersStore();
  const trackedValues = useRef<Record<string, string>>({});

  useEffect(() => {
    const { selectedRangeName, channel, currency } = filters;

    const trackingList = [
      { type: HOME_PAGE_EVENTS_PARAMS.CHANNEL, value: channel },
      { type: SHARED_EVENTS_PARAMS.CURRENCY, value: currency },
      { type: HOME_PAGE_EVENTS_PARAMS.TIME_RANGE, value: selectedRangeName },
    ];

    trackingList.forEach(({ type, value }) => {
      if (value && trackedValues.current[type] && trackedValues.current[type] !== value) {
        amplitude.track(HOME_PAGE_EVENTS.FILTER_APPLIED, { [type]: value });
      }
      if (value) {
        trackedValues.current[type] = value;
      }
    });
  }, [filters]);

  return (
    <div className={styles["overview"]}>
      <div className={styles["overview__row"]}>
        <div className={styles["overview__row__title"]}>{t('innerLayout.homePage.overview.overview')}</div>
        <DateRangesCompare disabled={isLoading} />
      </div>
      <div className={styles["overview__row"]}>
        {/* <Shortcuts /> */}
        <FiltersDropdowns />
      </div>
    </div>
  )
}

export default Overview;